import Route from '@ember/routing/route';
import { service } from '@ember/service';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type SessionContextService from 'tio-employee/services/session-context';
import type PslfProfileModel from 'tio-common/models/pslf-profile';
import type EmployeeModel from 'tio-common/models/employee';
import type CompanyModel from 'tio-common/models/company';

export default class AuthenticatedPslfRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;

  async model() {
    const currentEmployee = this.sessionContext.currentEmployee;
    // @ts-expect-error: fix model types
    const employee = await this.store.findRecord<EmployeeModel>('employee', currentEmployee?.id, {
      include: 'pslf-profile,pslf-forms,employee-addition',
      reload: true,
    });
    const companyId = employee?.company?.id as string;
    const company = await this.store.findRecord<CompanyModel>('company', companyId, {
      include: 'pslf-groups',
      reload: true,
    });
    let profile = employee.pslfProfile;
    if (!profile) {
      profile = this.store.createRecord<PslfProfileModel>('pslf-profile', {
        employee,
      });
      await profile.save();
    }
    return {
      pslfProfile: profile,
      groups: company.pslfGroups,
    };
  }
}
